let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fw5EH")).then(() => parcelRequire('4Ni8w'));